<section
  class="flash success"
  [class.open]="flash().visible && flash().type === 'success'"
>
  <div>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3333 4L5.99999 11.3333L2.66666 8" stroke="#15803D" stroke-width="1.66667"/>
    </svg>
  </div>


    <h5>{{ flash().message }}</h5>
</section>

<section
  class="flash failure"
  [class.open]="flash().visible && flash().type === 'failure'"
>
  <div>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4L4 12" stroke="#B91C1C" stroke-width="1.66667"/>
      <path d="M4 4L12 12" stroke="#B91C1C" stroke-width="1.66667"/>
    </svg>
  </div>

    <h5>{{ flash().message }}</h5>
</section>
